// Author Liang Gang Qiang
// Date 2021-10-13 17:24:50

class MintalMesPrdFurnaceBatch {
constructor({
        id = null,
        prdResultId = '',
        code = '',
        batch = '',
        startTime = '',
        endTime = '',
        status = '',
        remark = ''}
= {}) {
    this.id = id;
    this.prdResultId = prdResultId;
    this.code = code;
    this.batch = batch;
    this.startTime = startTime;
    this.endTime = endTime;
    this.status = status;
    this.remark = remark;
}
}

function newEntity() {
return new MintalMesPrdFurnaceBatch();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.mintal.prd.mintalMesPrdFurnaceBatch.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'shiftPlanCode',
        label: 'label.mintal.prd.mintalMesPrdFurnaceBatch.grid.shiftPlanCode',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'code',
        label: 'label.mintal.prd.mintalMesPrdFurnaceBatch.grid.code',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'batch',
        label: 'label.mintal.prd.mintalMesPrdFurnaceBatch.grid.batch',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'startTime',
        label: 'label.mintal.prd.mintalMesPrdFurnaceBatch.grid.startTime',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'endTime',
        label: 'label.mintal.prd.mintalMesPrdFurnaceBatch.grid.endTime',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'status',
        label: 'label.mintal.prd.mintalMesPrdFurnaceBatch.grid.status',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'remark',
        label: 'label.mintal.prd.mintalMesPrdFurnaceBatch.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        }
    ])}

const filter = {
    idFilter : "",
    idListFilter : "",
    prdResultIdFilter : "",
    codeFilter : "",
    batchFilter : "",
    startTimeRteFilter : "",
    startTimeLteFilter : "",
    endTimeRteFilter : "",
    endTimeLteFilter : "",
    statusFilter : ""
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'prdResultIdFilter',
        label: 'label.mintal.prd.mintalMesPrdFurnaceBatch.filter.prdResultId',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'mintalMesPrdProductionResult'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'codeFilter',
        label: 'label.mintal.prd.mintalMesPrdFurnaceBatch.filter.code',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'batchFilter',
        label: 'label.mintal.prd.mintalMesPrdFurnaceBatch.filter.batch',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'startTimeRteFilter',
        label: 'label.mintal.prd.mintalMesPrdFurnaceBatch.filter.startTimeRte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'startTimeLteFilter',
        label: 'label.mintal.prd.mintalMesPrdFurnaceBatch.filter.startTimeLte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'endTimeRteFilter',
        label: 'label.mintal.prd.mintalMesPrdFurnaceBatch.filter.endTimeRte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'endTimeLteFilter',
        label: 'label.mintal.prd.mintalMesPrdFurnaceBatch.filter.endTimeLte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'statusFilter',
        label: 'label.mintal.prd.mintalMesPrdFurnaceBatch.filter.status',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'prdResultId',
        label: 'label.mintal.prd.mintalMesPrdFurnaceBatch.entity.prdResultId',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'mintalMesPrdProductionResult'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'code',
        label: 'label.mintal.prd.mintalMesPrdFurnaceBatch.entity.code',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'batch',
        label: 'label.mintal.prd.mintalMesPrdFurnaceBatch.entity.batch',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'startTime',
        label: 'label.mintal.prd.mintalMesPrdFurnaceBatch.entity.startTime',
        sortable: true,
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'endTime',
        label: 'label.mintal.prd.mintalMesPrdFurnaceBatch.entity.endTime',
        sortable: true,
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'remark',
        label: 'label.mintal.prd.mintalMesPrdFurnaceBatch.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        }
]

export {MintalMesPrdFurnaceBatch, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
